<template>
  <cdp-Header />
  <div class="bg-cdp-grey-100 pt-[60px]">
    <div class="flex justify-between">
      <cdp-Navbar class="duration-100" />
      <div class="flex w-full flex-wrap">
        <div class="h-full w-full">
          <router-view :key="key" />
        </div>
        <cdp-Footer class="p-4" />
      </div>
    </div>
  </div>
  <asset-modal />
</template>

<script>
import header from '@/layouts/Header.vue';
import navbar from '@/layouts/Navbar.vue';
import footer from '@/layouts/Footer.vue';

import assetModal from '@/pages/Asset/AssetModal.vue';

import { routerStore } from '@/stores/route.js';

import { computed, watch } from 'vue';
export default {
  name: 'DefaultIndex',
  components: {
    'cdp-Header': header,
    'cdp-Navbar': navbar,
    'cdp-Footer': footer,
    assetModal
  },
  setup() {
    const storeRoute = routerStore();
    const { route } = storeRoute;

    // for force refresh pages give router-view key
    const crypto = window.crypto || window.msCrypto;
    const array = new Uint32Array(1);
    crypto.getRandomValues(array);
    const key = computed(() => route.path + array[0]);

    watch(
      () => route.matched,
      () => {
        // init scroll top when change path
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }
    );

    return {
      key
    };
  }
};
</script>